import React from "react";
import { observer } from "mobx-react";
import { Button, Card, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import "../../styles/ReplacePanoramaPage/Immersive3dTourPanorama.less";

@observer
class Immersive3dTourPanorama extends React.Component {
  ref = null;

  constructor(props) {
    super(props);

    this.ref = React.createRef();
  }

  downloadImmersive3dTourOriginalImage() {
    const { panorama, getImmersive3dTourOriginalImageSignedUrlCallback } = this.props;

    // Always request a freshly-signed URL: it carries the
    // `response-content-disposition: attachment` param so the browser downloads
    // the file instead of opening it inline. We must NOT reuse the cached URL
    // here, because the processing-image modal fills that same cache with URLs
    // signed WITHOUT the disposition param, which makes the image open inline.
    getImmersive3dTourOriginalImageSignedUrlCallback(panorama.id).then(data => {
      if (!data) {
        return;
      }

      this.ref.current.href = data.url;
      this.ref.current.click();
    });
  }

  goToUploadReplacePanoramaSection() {
    const {
      panorama,
      getCachedImmersive3dTourOriginalImageCallback,
      getImmersive3dTourOriginalImageSignedUrlCallback,
      goToUploadReplacePanoramaSectionCallback,
    } = this.props;

    const immersive3dTourOriginalImage = getCachedImmersive3dTourOriginalImageCallback(panorama.id);

    if (typeof immersive3dTourOriginalImage !== "undefined") {
      goToUploadReplacePanoramaSectionCallback(panorama.id);

      return;
    }

    getImmersive3dTourOriginalImageSignedUrlCallback(panorama.id).then(() => {
      goToUploadReplacePanoramaSectionCallback(panorama.id);
    });
  }

  render() {
    const { panorama, getImmersive3dTourCubeUrlCallback, openProcessingImageModalCallback } = this.props;

    return (
      <div className="immersive3dTourPanorama ui card">
        <div>
          <div className="immersive3dTourPanoramaMessage">
            {typeof panorama.visible !== "undefined" && !panorama.visible && (
              <Button className="button-with-icon-only" basic icon inverted>
                <Icon name="eye slash" />
              </Button>
            )}
            <Button
              className="button-with-icon-only"
              basic
              icon
              inverted
              onClick={() => openProcessingImageModalCallback(panorama.id)}
            >
              <Icon name="edit outline" />
            </Button>
            <a ref={this.ref} style={{ display: "none" }}>
              Hidden link
            </a>
            <Button
              className="button-with-icon-only"
              basic
              icon
              inverted
              onClick={() => this.downloadImmersive3dTourOriginalImage()}
            >
              <Icon name="cloud download" />
            </Button>
            <Button
              className="button-with-icon-only"
              basic
              icon
              inverted
              onClick={() => {
                this.goToUploadReplacePanoramaSection();
              }}
            >
              <Icon name="cloud upload" />
            </Button>
          </div>
          <div
            className="immersive3dTourCube"
            style={{
              display: "inline-block",
              width: "100%",
              height: "120px",
              background: "center center / cover",
              backgroundImage: `url(${getImmersive3dTourCubeUrlCallback(panorama)})`,
            }}
          />
          <Card.Content extra>{`#${panorama.id}`}&nbsp;</Card.Content>
        </div>
      </div>
    );
  }
}

Immersive3dTourPanorama.propTypes = {
  panorama: PropTypes.object.isRequired,
  goToUploadReplacePanoramaSectionCallback: PropTypes.func.isRequired,
  getCachedImmersive3dTourOriginalImageCallback: PropTypes.func.isRequired,
  getImmersive3dTourOriginalImageSignedUrlCallback: PropTypes.func.isRequired,
  getImmersive3dTourCubeUrlCallback: PropTypes.func.isRequired,
  openProcessingImageModalCallback: PropTypes.func.isRequired,
};

export default Immersive3dTourPanorama;
